import { TIMEOUT_LIMIT } from './config';

const timeout = function (s) {
  return new Promise(function (_, reject) {
    setTimeout(function () {
      reject(new Error(`Request took too long! Timeout after ${s} seconds`));
    }, s * 1000);
  });
};

export const AJAX = async function(url, uploadData = undefined) {
  try {
    const fetchPromise = uploadData ? 
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(uploadData)
    }) : fetch(url);

    const res = await Promise.race([fetchPromise, timeout(TIMEOUT_LIMIT)]);
    const data = await res.json();

    if (!res.ok)
      throw new Error(`${data.message} (${res.status}: ${res.statusText})`);

    return data;
  } catch (err) {
    throw err;
  }
};
